<!--
  @description: 财务结算-开票注册-注册信息
  @filePath:src\modules\transport\bms\views\finance\invoiceRegistration\components\RegisterInfo\index.vue
-->
<template>
    <div class="registerInfo">
        <m-pane
            ref="invoiceRegisTable"
            class="invoiceRegisTable"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            pageID="financeInfo"
            :currentPage="currentPage"
            @search-btn="queryList"
            @start-btn="handleStartUsing"
            @stop-btn="handleStopUsing"
            @invoiceRegistration-btn="handleInvoiceRegistration"
            @row-db-click="handleRowDBClick"
            @selectChange="handleSelectChange"
            @pageChange="handlePageChange"
            @sizeChange="handleSizeChange">
        </m-pane>
    </div>
</template>
<script>

import mPane from '@/modules/transport/bms/components/Table/Index.vue';
import config from './config.js';
import { getInvoiceRegUrl, queryInvoiceRegInfo, changeEnableStatus } from '@/modules/transport/bms/api/invoiceRegistrationApi.js';
import mTableMixin from '@/modules/transport/bms/mixins/mTableMixin.js';
import { mapGetters } from 'vuex';
import userConfig from '@/config/user.env.js';

export default {
    name: 'RegisterInfo',
    mixins: [mTableMixin],
    components: { mPane },
    data() {
        return {
            config,
            invoiceRegistrationBtnLoading: false,
            jobId: ''
        };
    },
    computed: {
        ...mapGetters(['user'])
    },
    methods: {
        /** 查询 **/
        queryListExecute({ params, successCallback }) {
            params = { 'supplierCode': '' };
            queryInvoiceRegInfo(params).then(res => {
                if (res && +res.code === 0) {
                    this.jobId = res.data && res.data.length ? res.data[0].jobId : '';
                    this.$emit('dataLoad', this.jobId);
                    successCallback(res);
                }
            });
        },

        /** 启用 **/
        startUsingExecute ({ params, successCallback }) {
            const { status, jobId } = params.selected[0];
            if ([1, '1'].includes(status)) {
                this.$message.warning('当前数据已启用，请勿重复操作');
                return;
            }
            changeEnableStatus({
                jobId,
                status: 1
            }).then(res => {
                if (res && res.code === '0') {
                    successCallback();
                }
            });
        },
        /** 停用 **/
        stopUsingExecute ({ params, successCallback }) {
            const { status, jobId } = params.selected[0];
            if ([0, '0'].includes(status)) {
                this.$message.warning('当前数据已停用，请勿重复操作');
                return;
            }
            changeEnableStatus({
                jobId,
                status: 0
            }).then(res => {
                if (res && res.code === '0') {
                    successCallback();
                }
            });
        },
        /** 开票注册 **/
        handleInvoiceRegistration() {
            this.config.buttonList[0].loading = true;
            getInvoiceRegUrl({
                h5PageId: userConfig.env === 'PROD' ? '20240619' : '800' // 页面编号
            }).then(res => {
                if (res && res.code === '0') {
                    res.data.url && window.open(res.data.url, '_blank');
                }
            }).finally(() => {
                this.config.buttonList[0].loading = false;
            });
        }
    }
};
</script>
<style lang="less" scoped>
.registerInfo{
    /deep/ #myPane .row-bg{
        display: none !important;
    }
}
</style>